import api from './axiosInstance';

export interface TaskGenerationRules {
    autoGenerateOnProjectStart: boolean;
    generateForFutureDates: boolean;
    maxFutureDays: number;
}

export interface TaskAssignmentRules {
    autoAssignToEngineer: boolean;
    autoAssignToSupervisor: boolean;
    allowReassignment: boolean;
}

export interface TaskStatusRules {
    autoMarkOverdue: boolean;
    allowManualStatusChange: boolean;
    requireCompletionNotes: boolean;
}

export interface NotificationSettings {
    notifyOnTaskGeneration: boolean;
    notifyOnOverdue: boolean;
    notifyBeforeDueDate: boolean;
    daysBeforeNotification: number;
}

export interface GlobalTaskSettings {
    taskGenerationRules: TaskGenerationRules;
    taskAssignmentRules: TaskAssignmentRules;
    taskStatusRules: TaskStatusRules;
    notificationSettings: NotificationSettings;
    lastModifiedBy?: string;
    lastModifiedAt?: string;
}

export const globalTaskSettingsService = {
    /**
     * Get global task settings
     */
    getSettings: async (): Promise<GlobalTaskSettings> => {
        const response = await api.get('/global-task-settings');
        return response.data.data;
    },

    /**
     * Update global task settings
     */
    updateSettings: async (settings: Partial<GlobalTaskSettings>): Promise<GlobalTaskSettings> => {
        const response = await api.put('/global-task-settings', settings);
        return response.data.data;
    },

    /**
     * Reset global task settings to defaults
     */
    resetToDefaults: async (): Promise<GlobalTaskSettings> => {
        const response = await api.post('/global-task-settings/reset');
        return response.data.data;
    }
};
